<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <form method="post" @submit="send" class="indexUp">
                <div class="contenu pt-12">
                    <span class="open-book">
                        <p
                            class="text-2xl mb-4 leading-custom"
                        >Rajoutons un avatar pour votre profil</p>
                        <picture-input
                            ref="pictureInput"
                            width="200"
                            height="200"
                            margin="16"
                            accept="image/jpeg, image/png"
                            size="1"
                            button-class="btn"
                            :custom-strings="{
                                upload: '<p>Your device does not support file uploading.</p>', // HTML allowed
                                drag: 'Drag an image or <br>click here to select a file', // HTML allowed
                                tap: 'Tape ici pour selectionner ton avatar depuis ta galerie', // HTML allowed
                                change: 'Change Photo', // Text only
                                remove: 'Remove Photo', // Text only
                                select: 'Select a Photo', // Text only
                                selected: '<p>Photo successfully selected!</p>', // HTML allowed
                                fileSize: 'The file size exceeds the limit', // Text only
                                fileType: 'This file type is not supported.', // Text only
                                aspect: 'Landscape/Portrait' // Text only
                            }"
                            @change="onChange"
                        ></picture-input>
                    </span>
                    <span class="open-book">
                        <p class="text-2xl mb-4 leading-custom">Ainsi qu'une vraie photo de vous</p>
                        <picture-input
                            ref="pictureInput"
                            width="200"
                            height="200"
                            margin="16"
                            accept="image/jpeg, image/png"
                            size="1"
                            button-class="btn"
                            :custom-strings="{
                                upload: '<p>Your device does not support file uploading.</p>', // HTML allowed
                                drag: 'Drag an image or <br>click here to select a file', // HTML allowed
                                tap: 'Tape ici pour selectionner ta photo depuis ta galerie', // HTML allowed
                                change: 'Change Photo', // Text only
                                remove: 'Remove Photo', // Text only
                                select: 'Select a Photo', // Text only
                                selected: '<p>Photo successfully selected!</p>', // HTML allowed
                                fileSize: 'The file size exceeds the limit', // Text only
                                fileType: 'This file type is not supported.', // Text only
                                aspect: 'Landscape/Portrait' // Text only
                            }"
                            @change="onChangePhoto"
                        ></picture-input>
                    </span>
                </div>
                <Submit></Submit>
            </form>
            <BoutonNext link="/inscription-email"></BoutonNext>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Submit from "@/components/inputs/Submit.vue";
import PictureInput from "vue-picture-input";

export default {
    name: "inscription-picture",
    components: {
        Header,
        Submit,
        PictureInput
    },
    data() {
        return {
            avatar: "",
            photo: ""
        };
    },
    computed: {
        userID: {
            get() {
                return this.$store.getters.currentAppData.userID;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    },
    methods: {
        onChange(image) {
            if (image) {
                this.avatar = image;
            } else {
                console.log(
                    "FileReader API not supported: use the <form>, Luke!"
                );
            }
        },
        onChangePhoto(image) {
            if (image) {
                this.photo = image;
            } else {
                console.log(
                    "FileReader API not supported: use the <form>, Luke!"
                );
            }
        },
        send(e) {
            e.preventDefault();
            this.axios
                .put("/api/users/" + this.userID + "/inscription/picture", {
                    avatar: this.avatar,
                    photo: this.photo
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push("/inscription-final");
                    }
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.inscription {
    margin-top: 60px;
    height: 100%;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px;
        text-align: left;
    }
}

.open-book {
    p:first-of-type {
        text-indent: 0;
    }

    p:first-of-type:first-letter {
        float: left;
        font: 700 3em/0.65 "sunshiney", sans-serif;
        padding: 0.15em 0.15em 0 0;
        text-transform: uppercase;
    }
}
</style>